@if (showHeadline()) {
    <div
        class="add--header"
        data-testid="t-discounts-div-1752672977568-3"
    >
        <div
            class="col"
            data-testid="t-discounts-div-1752672977568-1"
        >
            <span
                class="h5"
                data-testid="t-discounts-span-1752672977568-1"
                >{{ 'mws.discounts' | i18n }}:</span
            >
        </div>
        @if (updateable() && showButtons() && coreService.checkAbility('execute', 'supplier.contract.discount.new')) {
            <div
                class="col-auto text-end"
                data-testid="t-discounts-div-1752672977568-2"
            >
                <a
                    class="btn btn-sm action--btn btn-primary"
                    [attr.aria-label]="'mws.add' | i18n"
                    (click)="openNewDiscountModal()"
                    data-testid="t-discounts-a-1752672977568-1"
                    ><i
                        class="oc-plus"
                        data-testid="t-discounts-i-1752672977568-1"
                    ></i
                ></a>
            </div>
        }
    </div>
}

<div
    class="table-oc-responsive table-responsive table-scrollable"
    data-testid="t-discounts-div-1752672977568-9"
>
    <table
        cdk-table
        [dataSource]="supplierService.supplierContractDetail?.supplierDiscounts"
        multiTemplateDataRows
        class="table"
        data-testid="t-discounts-table-1752672977568-1"
    >
        <!-- Position Column -->
        <ng-container cdkColumnDef="typedescr">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-discounts-th-1752672977568-1"
            >
                {{ 'mws.discount.typedescr' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-discounts-td-1752672977568-1"
            >
                @if (coreService.checkAbility('read', 'supplierdiscount.discount.typedescr')) {
                    <div data-testid="t-discounts-div-1752672977568-4">
                        {{ element.discount['typedescr'] }}
                    </div>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="condition">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-discounts-th-1752672977568-2"
            >
                {{ 'mws.discount.conditiondesc' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-discounts-td-1752672977568-2"
            >
                @if (coreService.checkAbility('read', 'supplierdiscount.condition')) {
                    <div data-testid="t-discounts-div-1752672977568-5">
                        {{ element.condition }}
                    </div>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="conditionValue">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-discounts-th-1752672977568-3"
            >
                {{ 'mws.discount.conditionvalue' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-discounts-td-1752672977568-3"
            >
                @if (coreService.checkAbility('read', 'supplierdiscount.conditionvalue')) {
                    <div data-testid="t-discounts-div-1752672977568-6">
                        {{
                            element.conditionValue
                                | currency
                                    : environmentService.currencyHash.get(supplierService.supplierBasedata.currencyId)?.iso4217Code
                                    : 'symbol'
                                    : '1.2-2'
                                    : environmentService.appSettings.locale
                        }}
                    </div>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="discountValue">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-discounts-th-1752672977568-4"
            >
                {{ 'mws.discount.discountvalue' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-discounts-td-1752672977568-4"
            >
                @if (coreService.checkAbility('read', 'supplierdiscount.discountvalue')) {
                    <div data-testid="t-discounts-div-1752672977568-7">
                        {{ element.discountValue | number: '1.2-2' : environmentService.appSettings.locale }}
                        {{ element.isDiscountPercent ? '%' : environmentService.currencyHash.get(supplierService.supplierBasedata.currencyId)?.currencySymbol }}
                        <!-- stimmt so! hier currencySymbol -->
                    </div>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="isDiscountPercent">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-discounts-th-1752672977568-5"
            >
                {{ 'mws.discount.discountdesc' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-discounts-td-1752672977568-5"
            >
                @if (coreService.checkAbility('read', 'supplierdiscount.discount.descr')) {
                    <div data-testid="t-discounts-div-1752672977568-8">
                        {{ element.discount.descr }}
                    </div>
                }
            </td>
        </ng-container>
        @if (showButtons()) {
            <ng-container cdkColumnDef="buttons">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-discounts-th-1752672977568-6"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    align="right"
                    data-testid="t-discounts-td-1752672977568-6"
                >
                    @if (coreService.checkAbility('execute', 'supplier.contract.discount.edit') && updateable()) {
                        <a
                            class="btn btn-sm action--btn btn-primary"
                            [attr.aria-label]="'mws.edit' | i18n"
                            (click)="openEditDiscountModal(element)"
                            data-testid="t-discounts-a-1752672977568-2"
                        >
                            <i
                                class="oc-general-edit"
                                data-testid="t-discounts-i-1752672977568-2"
                            ></i>
                        </a>
                    }
                    @if (coreService.checkAbility('execute', 'supplier.contract.discount.delete') && updateable()) {
                        <a
                            class="btn btn-danger btn-sm action--btn"
                            [attr.aria-label]="'button.delete' | i18n"
                            (click)="openDeleteModal(element.id)"
                            data-testid="t-discounts-a-1752672977568-3"
                        >
                            <i
                                class="oc-trash-can"
                                data-testid="t-discounts-i-1752672977568-3"
                            ></i>
                        </a>
                    }
                </td>
            </ng-container>
        }

        <tr
            cdk-header-row
            *cdkHeaderRowDef="displayedColumns"
            data-testid="t-discounts-tr-1752672977568-1"
        ></tr>
        <tr
            cdk-row
            *cdkRowDef="let element; columns: displayedColumns"
            class="table-oc-row is-clickable"
            data-testid="t-discounts-tr-1752672977568-2"
        ></tr>
    </table>
</div>

<ng-template
    #discountModal
    let-c="close"
    let-d="dismiss"
>
    <!--    (ngSubmit)="submit(supplierContactForm)"-->
    <form
        [formGroup]="discountForm"
        class="customer-form"
        novalidate
        data-testid="t-discounts-form-1752672977568-1"
    >
        <div
            class="modal-header"
            data-testid="t-discounts-div-1752672977568-10"
        >
            <button
                type="button"
                id="discount-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                (click)="d('Close click')"
                data-testid="t-discounts-button-1752672977568-1"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-discounts-i-1752672977568-4"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-discounts-span-1752672977568-2"
                >{{ discountModalHeader }}</span
            >
        </div>

        <div
            class="modal-body"
            data-testid="t-discounts-div-1752672977568-27"
        >
            <div
                class="row g-3"
                data-testid="t-discounts-div-1752672977568-19"
            >
                <div
                    class="form-group col-md-4"
                    data-testid="t-discounts-div-1752672977568-11"
                >
                    <oc-label
                        [forElement]="'discount'"
                        [schema]="privilegeContext() + 'Discount'"
                        [propertyName]="'discount'"
                        [value]="'mws.discount.discountdesc' | i18n"
                        [classes]="'form-label'"
                        data-testid="t-discounts-oc-label-1752672977568-1"
                    ></oc-label>

                    <select
                        formControlName="discount"
                        class="form-select"
                        data-testid="t-discounts-select-1752672977568-1"
                    >
                        @for (dt of supplierService.discounts; track dt) {
                            <option
                                [ngValue]="dt.id"
                                data-testid="t-discounts-option-1752672977568-1"
                            >
                                {{ dt.typedescr }}
                            </option>
                        }
                    </select>
                </div>

                <div
                    class="form-group col-md-2"
                    data-testid="t-discounts-div-1752672977568-13"
                >
                    @if (coreService.checkAbility('create', 'supplierdiscount.condition') || coreService.checkAbility('update', 'supplierdiscount.condition')) {
                        <div
                            class="select-wrapper"
                            data-testid="t-discounts-div-1752672977568-12"
                        >
                            <oc-label
                                [forElement]="'condition'"
                                [schema]="privilegeContext() + 'Discount'"
                                [propertyName]="'condition'"
                                [value]="'mws.discount.conditiondesc' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-discounts-oc-label-1752672977568-2"
                            ></oc-label>
                            <select
                                formControlName="condition"
                                class="form-select"
                                data-testid="t-discounts-select-1752672977568-2"
                            >
                                @for (condition of conditions; track condition) {
                                    <option
                                        [ngValue]="condition"
                                        data-testid="t-discounts-option-1752672977568-2"
                                    >
                                        {{ condition }}
                                    </option>
                                }
                            </select>
                        </div>
                    }
                </div>
                <div
                    class="form-group col-md-6"
                    data-testid="t-discounts-div-1752672977568-18"
                >
                    @if (
                        coreService.checkAbility('create', 'supplierdiscount.conditionvalue') ||
                        coreService.checkAbility('update', 'supplierdiscount.conditionvalue')
                    ) {
                        <div data-testid="t-discounts-div-1752672977568-17">
                            <oc-label
                                forElement="conditionValue"
                                propertyName="conditionValue"
                                classes="form-label"
                                [schema]="privilegeContext() + 'Discount'"
                                [value]="'mws.discount.conditionvalue' | i18n"
                                data-testid="t-discounts-oc-label-1752672977568-3"
                            ></oc-label>
                            <div
                                class="input-group"
                                data-testid="t-discounts-div-1752672977568-16"
                            >
                                <input
                                    type="number"
                                    class="form-control"
                                    id="conditionValue"
                                    formControlName="conditionValue"
                                    (click)="$any($event.target).select()"
                                    [digits]="2"
                                    placeholder="z.B. 300"
                                    data-testid="t-discounts-input-1752672977568-1"
                                />
                                <div
                                    class="input-group-append"
                                    data-testid="t-discounts-div-1752672977568-15"
                                >
                                    <div
                                        class="input-group-text"
                                        data-testid="t-discounts-div-1752672977568-14"
                                    >
                                        <span data-testid="t-discounts-span-1752672977568-3">€</span>
                                    </div>
                                </div>
                            </div>
                            <oc-validator-error
                                [control]="discountForm.controls.conditionValue"
                                [propertyName]="'conditionValue'"
                                [inputElementId]="'conditionValue'"
                                data-testid="t-discounts-oc-validator-error-1752672977568-1"
                            ></oc-validator-error>
                        </div>
                    }
                </div>
            </div>

            <div
                class="separator"
                data-testid="t-discounts-div-1752672977568-20"
            >
                {{ 'mws.discount.typedescr' | i18n }}: {{ getDiscountFromArray(discountForm.get('discount').value).descr }}
            </div>

            <div
                class="row g-3"
                data-testid="t-discounts-div-1752672977568-26"
            >
                <div
                    class="form-group col-md-6"
                    data-testid="t-discounts-div-1752672977568-22"
                >
                    @if (
                        coreService.checkAbility('create', 'supplierdiscount.discountvalue') ||
                        coreService.checkAbility('update', 'supplierdiscount.discountvalue')
                    ) {
                        <div data-testid="t-discounts-div-1752672977568-21">
                            <oc-label
                                [forElement]="'discountValue'"
                                [schema]="privilegeContext() + 'Discount'"
                                [propertyName]="'discountValue'"
                                [value]="'mws.discount.discountvalue' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-discounts-oc-label-1752672977568-4"
                            ></oc-label>
                            <input
                                type="number"
                                class="form-control"
                                id="discountValue"
                                formControlName="discountValue"
                                (click)="$any($event.target).select()"
                                [digits]="2"
                                placeholder="{{ 'mws.discount.example' | i18n }}"
                                data-testid="t-discounts-input-1752672977568-2"
                            />
                            <oc-validator-error
                                [control]="discountForm.controls.discountValue"
                                [propertyName]="'discountValue'"
                                [inputElementId]="'discountValue'"
                                data-testid="t-discounts-oc-validator-error-1752672977568-2"
                            ></oc-validator-error>
                        </div>
                    }
                </div>
                <div
                    class="form-group col-md-6"
                    data-testid="t-discounts-div-1752672977568-25"
                >
                    @if (
                        coreService.checkAbility('create', 'supplierdiscount.discountvalue') ||
                        coreService.checkAbility('update', 'supplierdiscount.discountvalue')
                    ) {
                        <div data-testid="t-discounts-div-1752672977568-24">
                            <div
                                class="select-wrapper"
                                data-testid="t-discounts-div-1752672977568-23"
                            >
                                <oc-label
                                    [forElement]="'isDiscountPercent'"
                                    [schema]="privilegeContext() + 'Discount'"
                                    [propertyName]="'isDiscountPercent'"
                                    [value]="'mws.discount.discountdesc' | i18n"
                                    [classes]="'form-label'"
                                    data-testid="t-discounts-oc-label-1752672977568-5"
                                ></oc-label>
                                <select
                                    id="discountType"
                                    class="form-select"
                                    formControlName="isDiscountPercent"
                                    data-testid="t-discounts-select-1752672977568-3"
                                >
                                    <option
                                        [ngValue]="false"
                                        selected
                                        data-testid="t-discounts-option-1752672977568-3"
                                    >
                                        {{ 'mws.euro' | i18n }}
                                    </option>
                                    <option
                                        [ngValue]="true"
                                        data-testid="t-discounts-option-1752672977568-4"
                                    >
                                        {{ 'mws.percent' | i18n }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div
            class="modal-footer"
            data-testid="t-discounts-div-1752672977568-29"
        >
            <div
                class="button-wrapper"
                data-testid="t-discounts-div-1752672977568-28"
            >
                <button
                    type="button"
                    id="discount-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    [disabled]="!discountForm.get('changed').touched"
                    (click)="saveDiscountModal(); c('Close click')"
                    data-testid="t-discounts-button-1752672977568-2"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-discounts-i-1752672977568-5"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template
    #discountMessageModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        data-testid="t-discounts-div-1752672977568-30"
    >
        <button
            type="button"
            id="discount-message-cancel"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            (click)="d('Close click')"
            data-testid="t-discounts-button-1752672977568-3"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-discounts-i-1752672977568-6"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-discounts-span-1752672977568-4"
            >{{ discountModalHeader }}</span
        >
    </div>

    <div
        class="modal-body"
        [innerHTML]="discountModalBody"
        data-testid="t-discounts-div-1752672977568-31"
    ></div>

    <div
        class="modal-footer"
        data-testid="t-discounts-div-1752672977568-33"
    >
        <div
            class="button-wrapper"
            data-testid="t-discounts-div-1752672977568-32"
        >
            <button
                type="button"
                id="discount-message-success"
                [attr.aria-label]="'button.check' | i18n"
                class="btn btn-success"
                (click)="deleteDiscount(); c('Close click')"
                data-testid="t-discounts-button-1752672977568-4"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-discounts-i-1752672977568-7"
                ></i>
            </button>
        </div>
    </div>
</ng-template>
